export function isInternalUrl(url, domain = 'https://www.udemy.com') {
  return url.startsWith(domain);
}
export function getDynamicWebContentQueryParams() {
  var _searchParams$get, _searchParams$get2, _searchParams$get3;
  const params = {
    content_preview_overrides: false,
    preview_mode: false
  };
  if (typeof window === 'undefined') {
    return params;
  }
  const searchParams = new URLSearchParams(window.location.search);
  params.content_preview_overrides = (_searchParams$get = (_searchParams$get2 = searchParams.get) === null || _searchParams$get2 === void 0 ? void 0 : _searchParams$get2.call(searchParams, 'content_preview_overrides')) !== null && _searchParams$get !== void 0 ? _searchParams$get : false;
  params.preview_mode = ((_searchParams$get3 = searchParams.get) === null || _searchParams$get3 === void 0 ? void 0 : _searchParams$get3.call(searchParams, 'preview_mode')) === 'true';
  return params;
}
//# sourceMappingURL=utils.js.map